export function getPrometheusEnabled(): boolean {
  try {
    return __ENABLE_PROMETHEUS__;
  } catch (err) {
    return false;
  }
}
